// /home/szymon/kreator2/frontend/src/App.js
// v103.0.0 – Dodajemy Route "/nowy-projekt" -> <NewProjectRedirect />

import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import './App.css';
import 'react-tooltip/dist/react-tooltip.css'; // Import stylów react-tooltip
import { Tooltip } from 'react-tooltip'; // Import komponentu Tooltip
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import OrderDetails from './components/OrderDetails';
import Editor from './components/Editor';
import TemplateDetails from './components/TemplateDetails';
import PdfEditor from './components/PdfEditor';
import PdfEditorTemplates from './components/PdfEditorTemplates';
// Usunięto import AdminAiSettings, bo jest renderowany w AdminDashboard
// import AdminAiSettings from './components/AdminAiSettings';

// NOWE importy:
import ClientOrderPanel from './components/ClientOrderPanel';
import ClientPdfEditor from './components/ClientPdfEditor';
import NewProjectRedirect from './components/NewProjectRedirect'; // Nowy komponent
import ClientHelpPage from './components/ClientHelpPage'; // Import strony pomocy
import { Info } from 'lucide-react'; // Dodajemy ikonę Info

const BACKEND_URL = process.env.REACT_APP_API_URL;

export default function App() {
  console.log("[App.js] => START FRONT (React). backendUrl=", BACKEND_URL);

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [tooltipsEnabled, setTooltipsEnabled] = useState(true); // Stan dla tooltipów

  useEffect(() => {
    console.log("[App.js] => check /admin/check-auth =>", BACKEND_URL);
    fetch(`${BACKEND_URL}/admin/check-auth`, { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        console.log("[App.js] => check-auth => data=", data);
        setIsAuthenticated(data.authenticated);
      })
      .catch((err) => {
        console.error("[App.js] => check-auth error =>", err);
        setIsAuthenticated(false);
      });
  }, []);

  const handleLogin = () => setIsAuthenticated(true);
  const handleLogout = () => setIsAuthenticated(false);

  return (
    <Router>
      {/* Dodajemy komponenty Tooltip globalnie z wysokim z-index */}
      <Tooltip id="editor-tooltip" style={{ zIndex: 99999 }} />
      <Tooltip id="client-panel-tooltip" style={{ zIndex: 99999 }} />
      <Routes>
        <Route
          path="/admin/login"
          element={
            !isAuthenticated ? (
              <AdminLogin onLogin={handleLogin} backendUrl={BACKEND_URL} />
            ) : (
              <Navigate to="/admin" />
            )
          }
        />

        <Route
          path="/admin"
          element={
            isAuthenticated ? (
              <AdminDashboard onLogout={handleLogout} backendUrl={BACKEND_URL} />
            ) : (
              <Navigate to="/admin/login" />
            )
          }
        />

        <Route
          path="/admin/orders/:id"
          element={
            isAuthenticated ? (
              <OrderDetails backendUrl={BACKEND_URL} />
            ) : (
              <Navigate to="/admin/login" />
            )
          }
        />

        <Route
          path="/admin/orders/:id/pdf-editor/:downloadKey"
          element={
            isAuthenticated ? (
              <PdfEditor backendUrl={BACKEND_URL} />
            ) : (
              <Navigate to="/admin/login" />
            )
          }
        />

        <Route
          path="/admin/templates/:id"
          element={
            isAuthenticated ? (
              <TemplateDetails backendUrl={BACKEND_URL} />
            ) : (
              <Navigate to="/admin/login" />
            )
          }
        />

        <Route
          path="/admin/templates/:id/pdf-editor/:downloadKey"
          element={
            isAuthenticated ? (
              <PdfEditorTemplates backendUrl={BACKEND_URL} />
            ) : (
              <Navigate to="/admin/login" />
            )
          }
        />

        {/* Usunięto dedykowaną trasę /admin/ai-settings */}

        {/* Strona główna => Editor */}
        <Route path="/" element={<Editor backendUrl={BACKEND_URL} tooltipsEnabled={tooltipsEnabled} setTooltipsEnabled={setTooltipsEnabled} />} />

        {/* Publiczny panel i edytor */}
        <Route
          path="/client/orders/:publicKey"
          element={<ClientOrderPanel backendUrl={BACKEND_URL} tooltipsEnabled={tooltipsEnabled} setTooltipsEnabled={setTooltipsEnabled} />} // Dodano przekazanie propsów tooltipsEnabled i setTooltipsEnabled
        />
        <Route
          path="/client/orders/:publicKey/pdf-editor/:downloadKey"
          element={<ClientPdfEditor backendUrl={BACKEND_URL} tooltipsEnabled={tooltipsEnabled} setTooltipsEnabled={setTooltipsEnabled} />}
        />

        {/* NOWA TRASA => /nowy-projekt?ID=7656 */}
        <Route
            path="/nowy-projekt"
            element={<NewProjectRedirect backendUrl={BACKEND_URL} />}
          />

          {/* Strona Pomocy */}
          <Route
            path="/help"
            element={<ClientHelpPage />}
          />
        </Routes>
    </Router>
  );
}
